export const SET_WARRANTY_SETTINGS_DATA_LOADING = "SET_WARRANTY_SETTINGS_DATA_LOADING";
export const SET_WARRANTY_SETTINGS_DATA = "SET_WARRANTY_SETTINGS_DATA";
export const SET_WARRANTY_PERIODS_DATA = "SET_WARRANTY_PERIODS_DATA";
export const CLEAR_WARRANTY_SETTINGS_DATA = "CLEAR_WARRANTY_SETTINGS_DATA";

